import { CALL_API } from 'middlewares/api';
import { NEWTUBE_API_SERVER } from 'configs/url';

const FETCH_FIELD_SETTINGS_REQUEST = 'foundation/myteam/FETCH_FIELD_SETTINGS_REQUEST';
const FETCH_FIELD_SETTINGS_SUCCESS = 'foundation/myteam/FETCH_FIELD_SETTINGS_SUCCESS';
const FETCH_FIELD_SETTINGS_FAIL = 'foundation/myteam/FETCH_FIELD_SETTINGS_FAIL';

export function fetchFieldSettings() {
  return {
    [CALL_API]: {
      types: [FETCH_FIELD_SETTINGS_REQUEST, FETCH_FIELD_SETTINGS_SUCCESS, FETCH_FIELD_SETTINGS_FAIL],
      url: `${NEWTUBE_API_SERVER}fieldSettings/myteam`,
    },
  };
}

export default function reducer(state = {
  isLoading: false,
  isLoaded: false,
  data: null,
}, action) {
  switch (action.type) {
    case FETCH_FIELD_SETTINGS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        isLoaded: false,
      });
    case FETCH_FIELD_SETTINGS_SUCCESS:
      const newData = {};
      action.response.data.forEach((baseField) => {
        newData[baseField.fieldCode] = {
          fieldCode: baseField.fieldCode,
          baseNames: baseField.names[0].text, // 方便確認變數的意義而已
          isDisplay: baseField.fieldSetting.isDisplay,
        };
      });

      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        data: newData,
      });
    case FETCH_FIELD_SETTINGS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        data: undefined,
      });
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyTeams/reducers/fieldSettingsReducer.js
 **/